// File: frontend/src/services/superAdmin/settingsService.js

import { apiService } from '../api';
import { API_ENDPOINTS } from '../../config/constants';

export const settingsService = {
  // Language Management
  getLanguageStrings: async (options = {}) => {
    console.group('Getting Language Strings');
    console.log('Options:', options);
    
    try {
      const response = await apiService.get(API_ENDPOINTS.MASTER.LANGUAGE.GET, {
        params: options
      });
      
      console.log('Language strings retrieved successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error getting language strings:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  createLanguageString: async (languageData) => {
    console.group('Creating Language String');
    console.log('Language Data:', languageData);
    
    try {
      const response = await apiService.post(API_ENDPOINTS.MASTER.LANGUAGE.CREATE, languageData);
      
      console.log('Language string created successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error creating language string:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  updateLanguageString: async (languageData) => {
    console.group('Updating Language String');
    console.log('Language Data:', languageData);
    
    try {
      const response = await apiService.put(API_ENDPOINTS.MASTER.LANGUAGE.UPDATE, languageData);
      
      console.log('Language string updated successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error updating language string:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  deleteLanguageString: async (string_id) => {
    console.group('Deleting Language String');
    console.log('String ID:', string_id);
    
    try {
      const response = await apiService.delete(API_ENDPOINTS.MASTER.LANGUAGE.DELETE, {
        data: { string_id }
      });
      
      console.log('Language string deleted successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error deleting language string:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  // Category Management
  getCategoryTypes: async (options = {}) => {
    console.group('Getting Category Types');
    console.log('Options:', options);
    
    try {
      const response = await apiService.get(API_ENDPOINTS.MASTER.LOOKUP.GET, {
        params: {
          type: 'category_type',
          ...options
        }
      });
      
      console.log('Category types retrieved successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error getting category types:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  getCategoryTypeById: async (id) => {
    console.group('Getting Category Type by ID');
    console.log('ID:', id);
    
    try {
      const response = await apiService.get(API_ENDPOINTS.MASTER.LOOKUP.GET, {
        params: {
          type: 'category_type',
          id
        }
      });
      
      console.log('Category type retrieved successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error getting category type by ID:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  getCategoryTypeByName: async (name) => {
    console.group('Getting Category Type by Name');
    console.log('Name:', name);
    
    try {
      const response = await apiService.get(API_ENDPOINTS.MASTER.LOOKUP.GET, {
        params: {
          type: 'category_type',
          name
        }
      });
      
      console.log('Category type retrieved successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error getting category type by name:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  getCategoryValues: async (category_type_id, options = {}) => {
    console.group('Getting Category Values');
    console.log('Category Type ID:', category_type_id);
    console.log('Options:', options);
    
    try {
      const response = await apiService.get(API_ENDPOINTS.MASTER.LOOKUP.GET, {
        params: {
          type: 'category_value',
          category_type_id,
          ...options
        }
      });
      
      console.log('Category values retrieved successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error getting category values:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  createCategoryType: async (categoryTypeData) => {
    console.group('Creating Category Type');
    console.log('Category Type Data:', categoryTypeData);
    
    try {
      const response = await apiService.post(API_ENDPOINTS.MASTER.LOOKUP.CREATE, {
        type: 'category_type',
        data: categoryTypeData
      });
      
      console.log('Category type created successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error creating category type:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  updateCategoryType: async (id, categoryTypeData) => {
    console.group('Updating Category Type');
    console.log('ID:', id);
    console.log('Category Type Data:', categoryTypeData);
    
    try {
      const response = await apiService.put(API_ENDPOINTS.MASTER.LOOKUP.UPDATE, {
        type: 'category_type',
        id,
        data: categoryTypeData
      });
      
      console.log('Category type updated successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error updating category type:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  deleteCategoryType: async (id) => {
    console.group('Deleting Category Type');
    console.log('ID:', id);
    
    try {
      const response = await apiService.delete(API_ENDPOINTS.MASTER.LOOKUP.DELETE, {
        data: {
          type: 'category_type',
          id
        }
      });
      
      console.log('Category type deleted successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error deleting category type:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  createCategoryValue: async (category_type_id, categoryValueData) => {
    console.group('Creating Category Value');
    console.log('Category Type ID:', category_type_id);
    console.log('Category Value Data:', categoryValueData);
    
    try {
      // Ensure category_type_id is sent as a number
      const numericCategoryTypeId = parseInt(category_type_id, 10);
      
      if (isNaN(numericCategoryTypeId)) {
        throw new Error('Invalid category_type_id: must be a number');
      }
      
      const response = await apiService.post(API_ENDPOINTS.MASTER.LOOKUP.CREATE, {
        type: 'category_value',
        data: {
          category_type_id: numericCategoryTypeId,
          ...categoryValueData
        }
      });
      
      console.log('Category value created successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error creating category value:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  updateCategoryValue: async (id, categoryValueData) => {
    console.group('Updating Category Value');
    console.log('ID:', id);
    console.log('Category Value Data:', categoryValueData);
    
    try {
      const response = await apiService.put(API_ENDPOINTS.MASTER.LOOKUP.UPDATE, {
        type: 'category_value',
        id,
        data: categoryValueData
      });
      
      console.log('Category value updated successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error updating category value:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  deleteCategoryValue: async (id) => {
    console.group('Deleting Category Value');
    console.log('ID:', id);
    
    try {
      const response = await apiService.delete(API_ENDPOINTS.MASTER.LOOKUP.DELETE, {
        data: {
          type: 'category_value',
          id
        }
      });
      
      console.log('Category value deleted successfully:', response);
      console.groupEnd();
      return response.data || response;
    } catch (error) {
      console.error('Error deleting category value:', error);
      console.groupEnd();
      throw error;
    }
  },
  
  // Helper functions
  formatDate: (dateString) => {
    if (!dateString) return 'N/A';
    
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }
};

export default settingsService;